import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../Environment/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient) {}

  // ---------------------- Get Registered dashboard List API ---------------------- //

  getDashboardList(api: string) {
    return this.http.get(environment.baseUrl + api);
  }

  // ---------------------- Get Initial Registered dashboard List API By ID ---------------------- //

  getInitialUsersList(api: string, userTypeId: any) {
    const url = `${environment.baseUrl}${api}?userTypeId=${userTypeId}`;
    return this.http.get(url);
  }

  // ---------------------- Get Registered dashboard List API By ID ---------------------- //

  getDashboardCount(
    api: string,
    cityId: any = null,
    zoneId: any = null,
    userTypeId: any = null
  ) {
    let params: string = '';

    if (cityId) {
      params += params ? `&cityId=${cityId}` : `?cityId=${cityId}`;
    }

    if (zoneId) {
      params += params ? `&zoneId=${zoneId}` : `?zoneId=${zoneId}`;
    }

    if (userTypeId) {
      params += params
        ? `&UserTypeId=${userTypeId}`
        : `?UserTypeId=${userTypeId}`;
    }
    const url = `${environment.baseUrl}${api}${params}`;
    return this.http.get(url);
  }

  // ---------------------- Get Zone List by Id API ---------------------- //

  getZoneList(api: string, cityId: any): Observable<any> {
    const url = `${environment.baseUrl}${api}?CityId=${cityId}`;
    return this.http.get(url);
  }

  // ---------------------- Get Revenue List API ---------------------- //

  getRevenueData(api: string) {
    return this.http.get(environment.baseUrl + api);
  }

  // ---------------------- Get Filter Revenue List API For Chart ---------------------- //

  getRevenueDataForFilter(api: string, cityId: any, zoneId: any, year: any) {
    const url = `${environment.baseUrl}${api}?cityId=${cityId}&zoneId=${zoneId}&year=${year}`;
    return this.http.get(url);
  }

  getFilteredRevenueData(
    api: string,
    cityId: any = null,
    zoneId: any = null,
    year: any = null,
    fromDate: any = null,
    toDate: any = null
  ) {
    let params: string[] = [];

    if (cityId) params.push(`cityId=${cityId}`);
    if (zoneId) params.push(`zoneId=${zoneId}`);
    if (year) params.push(`year=${year}`);
    if (fromDate) params.push(`FromDate=${fromDate}`);
    if (toDate) params.push(`Todate=${toDate}`);

    const queryString = params.length ? `?${params.join('&')}` : '';
    const url = `${environment.baseUrl}${api}${queryString}`;

    console.log('Final API URL:', url);
    return this.http.get(url);
  }

  getSalesDashboardData(
    api: string,
    cityId: any = null,
    zoneId: any = null,
    year: any = null,
    fromDate: any = null,
    toDate: any = null
  ) {
    let params: string = '';

    if (cityId) {
      params = `?cityId=${cityId}`;
    }
    if (zoneId) {
      params = params + `&zoneId=${zoneId}`;
    }
    if (year) {
      params = params + (cityId ? `&year=${year}` : `?year=${year}`);
    }

    if (fromDate) {
      params =
        params + (fromDate ? `?Fromdate=${fromDate}` : `&Fromdate=${fromDate}`);
    }

    if (toDate) {
      params = params + `&Todate=${toDate}`;
    }

    const url = `${environment.baseUrl}${api}${params}`;
    return this.http.get(url);
  }

  getBaldiaDashboard(
    api: string,
    cityId: any = null,
    zoneId: any = null,
    userTypeId: any = null
  ) {
    let params: string = '';

    if (cityId) {
      params += params ? `&cityId=${cityId}` : `?cityId=${cityId}`;
    }

    if (zoneId) {
      params += params ? `&zoneId=${zoneId}` : `?zoneId=${zoneId}`;
    }

    if (userTypeId) {
      params += params
        ? `&UserTypeId=${userTypeId}`
        : `?UserTypeId=${userTypeId}`;
    }

    const url = `${environment.baseUrl}${api}${params}`;
    return this.http.get(url);
  }
}
